import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    superAdminButton: {
      backgroundColor: palette.navSuperAdminActions,
      '&:hover': {
        backgroundColor: palette.navSuperAdminActions,
      },
    },
    adminButton: {
      backgroundColor: palette.navAdminActions,
      '&:hover': {
        backgroundColor: palette.navAdminActions,
      },
    },
    operatorButton: {
      backgroundColor: palette.navOperatorActions,
      '&:hover': {
        backgroundColor: palette.navOperatorActions,
      },
    },
    summaryButton: {
      color: palette.white,
      fontSize: 12,
      fontWeight: 500,
      backgroundColor: palette.navCompanyContextActions,
      '&:hover': {
        backgroundColor: palette.navCompanyContextActions,
      },
    },
  });
